export default () => ({

    open: false,

    trigger: {
        ['x-on:click']() {
            this.open = !this.open;
        },
    },

    dialogue: {
        ['x-show']() {
            return this.open;
        },
        ['x-collapse']: '',
    },
})
